<template>
  <div class="modal-wrapper">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Alterar Dados do Curso
          </h4>
        </div>
        <div class="modal-body modal-body--scrollable">
          <table class="table table-striped">
            <tbody>
              <tr>
                <th>Instituição</th>
                <td>{{ billing.billing_institution.name }}</td>
              </tr>
              <tr>
                <th>Curso</th>
                <td>{{ billing.billing_course.name }}</td>
              </tr>
              <tr>
                <th>Campus</th>
                <td>{{ billing.billing_institution_place.name }}</td>
              </tr>
              <tr>
                <th>Nível</th>
                <td>{{ billing.billing_course.level }}</td>
              </tr>
              <tr>
                <th>Modalidade</th>
                <td>{{ billing.billing_course.kind }}</td>
              </tr>
              <tr>
                <th>Período</th>
                <td>{{ billing.billing_course.shift }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-body">
          <p>Curso:</p>
          <input class="form-control" type="string" v-model="newBillingCourse.name" placeholder="Novo curso">

          <p>Campus:</p>
          <input class="form-control" type="string" v-model="newBillingCourse.campus" placeholder="Novo campus">

          <p>Nível:</p>
          <select class="form-control" type="string" v-model="newBillingCourse.level">
            <option v-for="level in levels" :key="level" :value="level">
              {{ level }}
            </option>
          </select>

          <div class="row">
            <div class="col-md-6">
              <p>Modalidade:</p>
              <select class="form-control" type="string" v-model="newBillingCourse.kind">
                <option v-for="kind in kinds" :key="kind" :value="kind">
                  {{ kind }}
                </option>
              </select>
            </div>
            <div class="col-md-6">
              <p>Período:</p>
              <select class="form-control" type="string" v-model="newBillingCourse.shift">
                <option v-for="shift in shifts" :key="shift" :value="shift">
                  {{ shift }}
                </option>
              </select>
            </div>
          </div>
          <br>
          <div v-if="inputError" class="alert alert-danger">
            {{ inputError }}
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="updateBillingCourse" :disabled="isButtonDisabled">
            Salvar
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BillingsService from 'services/BillingsService';
import KindsService from 'services/KindsService';
import LevelsService from 'services/LevelsService';
import ShiftsService from 'services/ShiftsService';

export default {
  props: {
    billing: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      newBillingCourse: {
        name: this.billing.billing_course.name,
        campus: this.billing.billing_institution_place.name,
        level: this.billing.billing_course.level,
        kind: this.billing.billing_course.kind,
        shift: this.billing.billing_course.shift,
      },
      inputError: null,
      kinds: [],
      levels: [],
      shifts: [],
    };
  },
  methods: {
    ...mapActions([
      'loadStudentBillings',
    ]),

    loadKinds() {
      KindsService.getAll()
        .then((result) => {
          const kindList = result.flatMap(kind => kind.members.map(member => member.name));
          this.kinds = kindList;
        });
    },

    loadLevels() {
      LevelsService.getAll()
        .then((result) => {
          const levelList = result.flatMap(level => level.members).map(member => member.name);
          this.levels = levelList;
        });
    },

    loadShifts() {
      ShiftsService.getAll()
        .then((result) => {
          const shiftList = result.flatMap(shift => shift.name);
          this.shifts = shiftList;
        });
    },

    updateBillingCourse() {
      const currentBillingCourse = {
        name: this.billing.billing_course.name,
        campus: this.billing.billing_institution_place.name,
        level: this.billing.billing_course.level,
        kind: this.billing.billing_course.kind,
        shift: this.billing.billing_course.shift,
      };

      const isSameCourse = JSON.stringify(currentBillingCourse) === JSON.stringify(this.newBillingCourse);

      if (isSameCourse) {
        this.inputError = 'Os parâmetros passados correspondem ao curso atual';
        return;
      }

      BillingsService.updateBillingCourse(this.billing.id, this.newBillingCourse)
        .then(() => {
          this.$alert.notifySuccess('Curso atualizado com sucesso!');
          this.loadStudentBillings();
          this.$emit('close');
        })
        .catch((error) => {
          this.inputError = error?.response?.data?.message || 'Erro ao atualizar: contate o suporte.';
        })
        .finally(() => this.$loader.hide());
    },
  },
  computed: {
    isButtonDisabled() {
      return Object.values(this.newBillingCourse).some(value => !value);
    },
  },
  mounted() {
    this.loadKinds();
    this.loadLevels();
    this.loadShifts();
  },
};
</script>

<style scoped>
p {
  margin: 10px 0 0 0;
}

.modal-body {
  padding: 0px 15px 5px 15px;
}

.modal-body--scrollable {
  padding-top: 15px;
  padding-bottom: 0px;
}
</style>
